import {License, licenseSchema} from "./License";
import {useTranslation} from "react-i18next";
import React from "react";
import {makeRequired} from "../../../shared/components/forms/formUtils";
import {Grid} from "@mui/material";
import {MuiRhfTextField} from "../../../shared/components/forms/MuiRhfTextField";
import {Application} from "../Application";
import {CopyToClipboardButton} from "../../../shared/components/buttons/CopyToClipboardButton";
import {MuiRhfStringListDialogField} from "../../../shared/components/forms/MuiRhfStringListDialogField";

export function ServerLicenseForm(props: {
  application: Application,
  license: License,
  readOnly: boolean,
}) {
  const serverLicense = props.license.serverLicense;
  const formReadonly = props.readOnly;
  const {t} = useTranslation();

  const stdFieldProps = {
    variant: "outlined" as "outlined",
    disabled: formReadonly,
    InputLabelProps: {
      shrink: true
    }
  }
  const required = makeRequired(licenseSchema(t));
  return (
    <Grid item={true} xs={12} md={7} lg={8}>
      <Grid container={true} spacing={3}>
        <Grid item={true} xs={12} lg={6}>
          <MuiRhfTextField name={'serverLicense.name'}
                           label={t('License.serverLicense.name')}
                           fullWidth={true}
                           required={required.serverLicense.name}
                           {...stdFieldProps}
          />
        </Grid>
        <Grid item={true} xs={10} lg={5}>
          <MuiRhfTextField name={'serverLicense.key'}
                           label={t('License.serverLicense.key')}
                           fullWidth={true}
                           {...stdFieldProps}
                           disabled={!!serverLicense?.key && formReadonly}
                           placeholder={t("License.serverLicense.msgWillBeGenerated")}
          />
        </Grid>
        <Grid item={true} xs={2} lg={1} sx={{display: "flex", marginLeft: -1}}>
          <CopyToClipboardButton text={serverLicense?.key} />
        </Grid>
        <Grid item={true} xs={12} lg={6} sx={{alignItems: 'center', display: 'flex', justifyContent: 'center',}}>
          <MuiRhfStringListDialogField name={"serverLicense.allowedUris"}
                                       title={t("License.serverLicense.allowedUris")}
                                       inputLabel={t("License.serverLicense.buttonAddUri")}
                                       disabled={formReadonly} />
        </Grid>
      </Grid>
    </Grid>
  );
}
